import { render, staticRenderFns } from "./textStyleBuilder.vue?vue&type=template&id=4b9b2de4&"
import script from "./textStyleBuilder.vue?vue&type=script&lang=js&"
export * from "./textStyleBuilder.vue?vue&type=script&lang=js&"
import style0 from "../styleBuilder.scss?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports